/*
  Available Modules:
  - font-size
  - word-spacing
  - letter-spacing
  - line-height
  - cursor-size
  - contrast-modes
  - enlarged-buttons
  - simple-lang-toggle
  - simple-lang-button
  - reading-aid
  - magnifier
  - stop-animations
*/


/*
  Available Positions:
  - top-left
  - top-right
  - bottom-left
  - bottom-right
*/

let config = {
  simpleLanguageUrl: 'simple-language',
  simpleLanguageLabel: 'Zur einfachen Sprache wechseln',
  devMode: false,
  a11yDisclaimerUrl: '/barrierefreiheit',
  modules: [
    'a11y-nav',
    'font-size', 
    'word-spacing', 
    'letter-spacing', 
    'line-height', 
    'cursor-size', 
    'contrast-modes', 
    'enlarged-buttons', 
    'simple-lang-toggle',
    'reading-aid', 
    'stop-animations',
  ],
  widgetPos: {
    desktop: 'bottom-right',
    mobile: 'bottom-right'
  }
}

if (configOverride) {
  config = {
    ...config,
    ...configOverride
  }
}

export default config;
